import { NavLink } from 'react-router-dom';
import './Games.css';

const Tools = () => {
  return(
    <div className="Games-page">
      <div className="side-bar">
        {/* Placeholder for ad unit - will be populated with responsive ad code after approval */}
        <div className="ad-slot" id="tools-left-rail-ad" aria-label="Advertisement" />
      </div>
      <div className="Games-Container">
        <div className="games-header">
          <h1>🛠️ Useful Tools</h1>
          <p>Handy tools to make your life easier!</p>
        </div>
        
        <div className="game-icon">
          <div className="game-name">
            <h3>Character Counter</h3>
          </div>
          <div className="game-image">
            <NavLink to="/character-counter">
              <div className="professional-char-counter-card">
                <div className="card-background">
                  <div className="floating-elements">
                    <span className="game-element-1">A</span>
                    <span className="game-element-2">123</span>
                    <span className="game-element-3">📝</span>
                  </div>
                  <div className="main-icon">
                    <div className="counter-icon">
                      <div className="counter-center">🔢</div>
                    </div>
                  </div>
                  <div className="card-title">
                    <span className="title-text">Character Counter</span>
                    <span className="subtitle">Count your text instantly</span>
                  </div>
                  <div className="decorative-elements">
                    <div className="score-icon">📊</div>
                    <div className="speed-icon">⚡</div>
                  </div>
                </div>
              </div>
            </NavLink>
          </div>
        </div>

        <div className="game-icon">
          <div className="game-name">
            <h3>Card Creator</h3>
          </div>
          <div className="game-image">
            <NavLink to="/greeting-cards">
              <div className="professional-greeting-card">
                <div className="card-background">
                  <div className="floating-elements">
                    <span className="game-element-1">🎂</span>
                    <span className="game-element-2">💕</span>
                    <span className="game-element-3">�</span>
                  </div>
                  <div className="main-icon">
                    <div className="greeting-icon">
                      <div className="greeting-center">🎨</div>
                    </div>
                  </div>
                  <div className="card-title">
                    <span className="title-text">Greeting Cards</span>
                    <span className="subtitle">Create beautiful cards</span>
                  </div>
                  <div className="decorative-elements">
                    <div className="heart-icon">💖</div>
                    <div className="sparkle-icon">✨</div>
                  </div>
                </div>
              </div>
            </NavLink>
          </div>
        </div>      
      </div>    
      
      <div className="side-bar">
        {/* Placeholder for ad unit - will be populated with responsive ad code after approval */}
        <div className="ad-slot" id="tools-right-rail-ad" aria-label="Advertisement" />
      </div>
    </div>
  );
}
export default Tools;